import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { AverageSessionDuration } from "@/features/reporting/components/average-session-duration";
import { BaseAnalytics } from "@/features/reporting/components/base-analytics";
import { Concurrency } from "@/features/reporting/components/concurrency";
import { RoomUsage } from "@/features/reporting/components/room-usage";
import { RoomUsageByRoomSystem } from "@/features/reporting/components/room-usage-by-room-system";
import { ScheduledSessions } from "@/features/reporting/components/scheduled-sessions";

export function ReportingOverview() {
  return (
    <section>
      <OnboardingHeader
        title="Overview"
        description="Platform wide analytics"
        className="mb-6"
      />
      <div className="space-y-6">
        <BaseAnalytics />
        <Concurrency />
        <ScheduledSessions />
        <RoomUsage />
        <AverageSessionDuration />
        <RoomUsageByRoomSystem />
      </div>
    </section>
  );
}
